// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: S8350pIpoy

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicCloseButton.module.css"; // plasmic-import: S8350pIpoy/css

import ClosesvgIcon from "./icons/PlasmicIcon__Closesvg"; // plasmic-import: ze_MFlDSdi/icon

createPlasmicElementProxy;

export type PlasmicCloseButton__VariantMembers = {};
export type PlasmicCloseButton__VariantsArgs = {};
type VariantPropType = keyof PlasmicCloseButton__VariantsArgs;
export const PlasmicCloseButton__VariantProps = new Array<VariantPropType>();

export type PlasmicCloseButton__ArgsType = {};
type ArgPropType = keyof PlasmicCloseButton__ArgsType;
export const PlasmicCloseButton__ArgProps = new Array<ArgPropType>();

export type PlasmicCloseButton__OverridesType = {
  closeBtn?: p.Flex<"button">;
  svg?: p.Flex<"svg">;
};

export interface DefaultCloseButtonProps {
  className?: string;
}

const $$ = {};

function PlasmicCloseButton__RenderFunc(props: {
  variants: PlasmicCloseButton__VariantsArgs;
  args: PlasmicCloseButton__ArgsType;
  overrides: PlasmicCloseButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <button
      data-plasmic-name={"closeBtn"}
      data-plasmic-override={overrides.closeBtn}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.closeBtn
      )}
      ref={ref => {
        $refs["closeBtn"] = ref;
      }}
    >
      <ClosesvgIcon
        data-plasmic-name={"svg"}
        data-plasmic-override={overrides.svg}
        className={classNames(projectcss.all, sty.svg)}
        role={"img"}
      />
    </button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  closeBtn: ["closeBtn", "svg"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  closeBtn: "button";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCloseButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCloseButton__VariantsArgs;
    args?: PlasmicCloseButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicCloseButton__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicCloseButton__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCloseButton__ArgProps,
          internalVariantPropNames: PlasmicCloseButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCloseButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "closeBtn") {
    func.displayName = "PlasmicCloseButton";
  } else {
    func.displayName = `PlasmicCloseButton.${nodeName}`;
  }
  return func;
}

export const PlasmicCloseButton = Object.assign(
  // Top-level PlasmicCloseButton renders the root element
  makeNodeComponent("closeBtn"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicCloseButton
    internalVariantProps: PlasmicCloseButton__VariantProps,
    internalArgProps: PlasmicCloseButton__ArgProps
  }
);

export default PlasmicCloseButton;
/* prettier-ignore-end */
